<template>
  <div class="Mobile_Banner">
    <swiper :options="swiperOption" ref="mySwipers">
      <swiper-slide v-for="(item,index) in txt" :key="index">
        <!-- <img class="banner_img" src="../../assets/image/SdgsReports/1.png" alt="image" /> -->
        <div class="swiper_content">
          <div class="swiper_content_box">
            <div class="content_tit">
              <div class="content_txt">{{item.tit}}</div>
            </div>
            <div class="content_text">{{item.text}}</div>
          </div>
        </div>
      </swiper-slide>
    </swiper>

    <div class="pagination_boxs">
      <div class="swiper-paginations"></div>
    </div>
  </div>
</template>

<script>
// 引入插件
import { swiper, swiperSlide, Pagination } from "vue-awesome-swiper";
import {
  swiperAnimateCache,
  swiperAnimate
} from "@/assets/js/swiper.animate1.0.3.min.js";
import "swiper/dist/css/swiper.css";
export default {
  name: "Home",
  components: {
    swiper,
    swiperSlide,
    Pagination
  },
  data() {
    return {
      txt: [
        {
          tit: "Big Earth Data for SDGs",
          text:
            "Digital connections, shared prosperity, for our people, for our planet."
        },
        {
          tit: "Big Earth Data for SDGs",
          text:
            "Big earth data-driven innovations towards the Sustainable Development Goals, for a better world."
        },
        {
          tit: "Big Earth Data for SDGs",
          text:
            "Big earth data-driven innovations towards the Sustainable Development Goals, for a better world."
        },
        {
          tit: "Big Earth Data for SDGs",
          text:
            "Big earth data-driven innovations towards the Sustainable Development Goals, for a better world."
        },
        {
          tit: "Big Earth Data for SDGs",
          text:
            "Big earth data-driven innovations towards the Sustainable Development Goals, for a better world."
        },
        {
          tit: "Big Earth Data for SDGs",
          text:
            "Big earth data-driven innovations towards the Sustainable Development Goals, for a better world."
        }
      ],
      swiperOption: {
        loop: true,

        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        autoplay: {
          delay: 50000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        on: {
          init: function() {
            swiperAnimateCache(this);
            swiperAnimate(this);
          },
          slideChangeTransitionStart: function() {},
          slideChangeTransitionEnd: function() {},
          slideChange: function() {
            swiperAnimate(this);
          }
        }
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwipers.swiper;
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 767px) {
  .swiper {
    --swiper-theme-color: #ff6600; /* 设置Swiper风格 */
    --swiper-navigation-color: #00ff33; /* 单独设置按钮颜色 */
    --swiper-navigation-size: 30px; /* 设置按钮大小 */
  }
  .Mobile_Banner {
    background: rgba(0, 39, 78, 1);
    position: relative;
    overflow: hidden;
    height: calc(100vh - 0px);

    .swiper_content {
      position: absolute;
      top: 0px;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.1);
      color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .swiper_content_box {
          padding: 0 40px;
        width: 100%;
        background: url("../../../assets/image/Index/Technology_bg.png")
          no-repeat;
        background-size: cover;

        .content_tit {
          margin-top: 40px;
          width: 100%;
          word-wrap: break-word;
          font-family: Arial, Helvetica, sans-serif;

          .content_txt {
            width: 100%;
            word-wrap: break-word;
            font-family: Arial, Helvetica, sans-serif;
            font-size: 50px;
            font-weight: 600;
            color: #fff;
    
            margin-top: 0px;
          }
        }
        .content_text {
          width: 100%;
          word-wrap: break-word;
          //   background-image: -webkit-linear-gradient(right, #2e42ad, #27c5f4);
          font-family: Arial, Helvetica, sans-serif;
          font-size: 24px;
          font-weight: 600;
                  margin-bottom: 80px;
          //   color: #fff;
          color: #c4f0ff !important;
          margin-top: 40px;
        }
      }
    }
    .swiper-container {
      width: 100%;
      height: 100%;
    }
    .banner_img {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }
}
</style>